import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ThemeTablesBubbles from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.themeTablesBubbles,
  };
}

export default withRouter(connect(mapStateToProps)(ThemeTablesBubbles));



// WEBPACK FOOTER //
// ./src/components/ThemeTablesBubbles/container/index.js